import { comparisonOps } from './constants';

type ComparisonOp = (typeof comparisonOps)[number];

export function isComparisonOp(op: string): op is ComparisonOp {
  return comparisonOps.includes(op as ComparisonOp);
}
